export default __webpack_public_path__ + "static/media/autoPayBg.35ce007b.svg";